import React from 'react';
import { ZoomClient } from '../index-types';

interface ZoomContextType {
    zoomClient?: ZoomClient
    setZoomClient: (template: ZoomClient) => void
}

export default React.createContext<ZoomContextType>({} as any);